<div class='container-fluid'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert
    :variant="alert_variant"
    v-model="showAlert"
  >    
  </b-alert>

  <b-row class="mb-3">
    <b-col cols="12">
      <b-modal v-model="showModal" ref="actions" id="actions" title="Operazioni" @ok="handleOk">

        <div v-if="action_selected == 1">
          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Nome del nuovo lisitno
              </div>
            </b-col>
            <b-col cols="7">
              <b-form-input v-model="new_price_list_name"></b-form-input>
            </b-col>
          </b-row>          
          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Cliente assegnato listino
              </div>
            </b-col>
            <b-col cols="7">
              <select class="custom-select" v-model="customer_assign">
               <option></option>
                <option 
                  v-for="customer in customers_list" 
                  :key="customer.id" 
                  :value="customer.id"
                >
                  {{ customer.company }}
                </option>
              </select>
            </b-col>
          </b-row>          
          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Data inizio validità
              </div>
            </b-col>
            <b-col cols="7">
              <Datepicker 
                v-model="new_start_date" 
                :teleport="true"
                :input-class="'custom-input'"
                :icon-class="'custom-icon'"
                :format="dateFormat" 
                :locale="locale" 
                :show-cancel-btn=false 
                :show-select-btn= false
                :enable-time-picker= false
                :auto-apply= "true"
              />
            </b-col>
          </b-row>          
          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Data fine validità
              </div>
            </b-col>
            <b-col cols="7">
              <Datepicker 
                v-model="new_end_date" 
                :teleport="true"
                :input-class="'custom-input'"
                :icon-class="'custom-icon'"
                :format="dateFormat" 
                :locale="locale" 
                :show-cancel-btn=false 
                :show-select-btn= false
                :enable-time-picker= false
                :auto-apply= "true"
              />
            </b-col>
          </b-row>          
        </div>
        
        <div v-if="action_selected == 2">

          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Nome del cliente
              </div>
            </b-col>
            <b-col cols="7">
              <select class="custom-select" v-model="add_customer">
                <option></option>
                <option 
                  v-for="customer in customers_list" 
                  :key="customer.id" 
                  :value="customer.id"
                >
                  {{ customer.company }}
                </option>
              </select>
            </b-col>
          </b-row>          

          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Nome del listino a cui aggiungere
              </div>
            </b-col>
            <b-col cols="7">
              <select 
                class="custom-select"
                v-model="add_price_list_name"
              >
                <option></option>
                <option 
                  v-for="price_list_name in price_list_names" 
                  :key="price_list_name.id" 
                  :value="price_list_name.price_list_name"
                >
                  {{ price_list_name.price_list_name }}
                </option>
              </select>
            </b-col>
          </b-row>

        </div>
        
        <div v-if="action_selected == 3">

          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Importo unitario
              </div>
            </b-col>
            <b-col cols="3">
              <b-form-input v-model="update_unit_amount"></b-form-input>
            </b-col>
            <b-col cols="4">
              <select class="custom-select" v-model="update_unit_amount_kind">
                <option :key="1" :value="1">Percentuale</option>
                <option :key="2" :value="1">Fisso</option>
              </select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="5">
              <div class='label'>
                Costo unitario
              </div>
            </b-col>
            <b-col cols="3">
              <b-form-input v-model="update_unit_cost"></b-form-input>
            </b-col>
            <b-col cols="4">
              <select class="custom-select" v-model="update_unit_cost_kind">
                <option :key="1" :value="1">Percentuale</option>
                <option :key="2" :value="1">Fisso</option>
              </select>
            </b-col>
          </b-row>          

          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Data inizio validità
              </div>
            </b-col>
            <b-col cols="7">
              <Datepicker 
                v-model="update_start_date" 
                :teleport="true"
                :input-class="'custom-input'"
                :icon-class="'custom-icon'"
                :format="dateFormat" 
                :locale="locale" 
                :show-cancel-btn=false 
                :show-select-btn= false
                :enable-time-picker= false
                :auto-apply= "true"
              />
            </b-col>
          </b-row>          
          <b-row class="mb-3">
            <b-col cols="5">
              <div class='label'>
                Data fine validità
              </div>
            </b-col>
            <b-col cols="7">
              <Datepicker 
                v-model="update_end_date" 
                :teleport="true"
                :input-class="'custom-input'"
                :icon-class="'custom-icon'"
                :format="dateFormat" 
                :locale="locale" 
                :show-cancel-btn=false 
                :show-select-btn= false
                :enable-time-picker= false
                :auto-apply= "true"
              />
            </b-col>
          </b-row>       

        </div>

      </b-modal>
    </b-col>
  </b-row>


  <b-row class="mb-3">
    <b-col cols="12">

      <b-card      
        title="Clona Listino"
        subtitle="Scegliere le voci per cui si intende filtrare"
      >
        <b-card-body style="text-align: left;">

      <!-- Nome listino e nome cliente -->
          <b-row>
            <b-col cols='6'>
              <div class='label'>Cliente</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Listino</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="filter.customer_id"
              >
                <option></option>
                <option 
                  v-for="customer in customers_list" 
                  :key="customer.id" 
                  :value="customer.id"
                >
                  {{ customer.company }}
                </option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="filter.price_list_name"
              >
                <option></option>
                <option 
                  v-for="price_list_name in price_list_names" 
                  :key="price_list_name.id" 
                  :value="price_list_name.price_list_name"
                >
                  {{ price_list_name.price_list_name }}
                </option>
              </select>
            </b-col>
          </b-row>

      <!-- Nome della voce e base -->

          <b-row>
            <b-col cols='6'>
              <div class='label'>Base</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Nome della voce</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="filter.base_id"
              >
                <option></option>
                <option 
                  v-for="base in bases" 
                  :key="base.id" 
                  :value="base.id"
                >
                  {{ base.base_code }}
                </option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="filter.voice_name_id"
              >
                <option></option>
                <option 
                  v-for="voice_name in voice_names" 
                  :key="voice_name.id" 
                  :value="voice_name.id"
                >
                  {{ voice_name.voice_name }}
                </option>
              </select>
            </b-col>
          </b-row>

      <!-- Data inizio, data fine validità, nome della voce e valuta, tipo merce e tipo imballaggio-->
          <b-row>
            <b-col cols='2'>
              <div class='label'>Data inizio validità</div> 
            </b-col>
            <b-col cols='2'>
              <div class='label'>Data fine validità</div> 
            </b-col>
            <b-col cols='1'>
              <div class='label'>Unità di misura</div> 
            </b-col>
            <b-col cols='1'>
              <div class='label'>Valuta</div> 
            </b-col>
            <b-col cols='3'>
              <div class='label'>Tipologia merce</div> 
            </b-col>
            <b-col cols='3'>
              <div class='label'>Tipologia imballaggio</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='2'>
              <div class="d-flex mb-2" style="">
                <Datepicker 
                  v-model="filter.start_date" 
                  :teleport="true"
                  :input-class="'custom-input'"
                  :icon-class="'custom-icon'"
                  :format="dateFormat" 
                  :locale="locale" 
                  :show-cancel-btn=false 
                  :show-select-btn= false
                  :enable-time-picker= false
                  :auto-apply= "true"
                />
              </div>
            </b-col>
            <b-col cols='2'>
              <div class="d-flex mb-2" style="">
                <Datepicker 
                  v-model="filter.end_date" 
                  :teleport="true"
                  :input-class="'custom-input'"
                  :icon-class="'custom-icon'"
                  :format="dateFormat" 
                  :locale="locale" 
                  :show-cancel-btn=false 
                  :show-select-btn= false
                  :enable-time-picker= false
                  :auto-apply= "true"
                />
              </div>
            </b-col>
            <b-col cols='1'>
              <select 
                class="custom-select"
                v-model="filter.measure_unit_id"
              >
                <option></option>
                <option 
                  v-for="measure_unit in measure_units" 
                  :key="measure_unit.id" 
                  :value="measure_unit.id"
                >
                  {{ measure_unit.measure_unit }}
                </option>
              </select>
            </b-col>
            <b-col cols='1'>
              <select 
                class="custom-select"
                v-model="filter.currency_id"
              >
                <option></option>
                <option 
                  v-for="currency in currencies" 
                  :key="currency.id" 
                  :value="currency.id"
                >
                  {{ currency.currency }}
                </option>
              </select>
            </b-col>
            <b-col cols='3'>
              <select 
                class="custom-select"
                v-model="filter.good_kind_id"
              >
                <option></option>
                <option 
                  v-for="good_kind in goods_kinds" 
                  :key="good_kind.id" 
                  :value="good_kind.id"
                >
                  {{ good_kind.kind }}
                </option>
              </select>
            </b-col>
            <b-col cols='3'>
              <select 
                class="custom-select"
                v-model="filter.packaging_kinds_id"
              >
                <option></option>
                <option 
                  v-for="packaging_kind in packaging_kinds" 
                  :key="packaging_kind.id" 
                  :value="packaging_kind.id"
                >
                  {{ packaging_kind.description }}
                </option>
              </select>
            </b-col>
          </b-row>

      <!-- Locazione 1 e Locazione 2 -->
          <b-row>
            <b-col cols='6'>
              <div class='label'>Locazione 1</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Locazione 2</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="filter.location_code1_id"
              >
                <option></option>
                <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.location }}</option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="filter.location_code2_id"
              >
                <option></option>
                <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.location }}</option>
              </select>
            </b-col>
          </b-row>
          
      <!-- Formula, importo e costo unitario -->
          <b-row>
            <b-col cols='4'>
              <div class='label'>Formula</div> 
            </b-col>
            <b-col cols='1'>
              <div class='label'>Importo unitario</div> 
            </b-col>
            <b-col cols='1'>
              <div class='label'>Costo unitario</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='4'>
              <select 
                class="custom-select"
                v-model="filter.formula_id"
              >
                <option></option>
                <option 
                  v-for="calculation_formula in calculation_formulas" 
                  :key="calculation_formula.id" 
                  :value="calculation_formula.id"
                >
                  {{ calculation_formula.formula }}
                </option>
              </select>
            </b-col>
            <b-col cols='1'>
              <b-form-input v-model="filter.unit_amount" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='1'>
              <b-form-input v-model="filter.unit_cost" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='1'>
              <b-button variant="outline-warning" @click="clearForm">&nbsp;&nbsp;&nbsp;&nbsp;Pulisci&nbsp;&nbsp;&nbsp;&nbsp;</b-button>
            </b-col>
            <b-col cols='1'>
              <b-button variant="primary" @click="filterData">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Filtra&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b-button>
            </b-col>
            <b-col cols='2'>
              <select 
                class="custom-select"
                v-model="action_selected"
              >
                <option value="0">Seleziona il tipo di operazione</option>
                <option 
                  v-for="operation in operations" 
                  :key="operation.id" 
                  :value="operation.id"
                >
                  {{ operation.value }}
                </option>
              </select>
            </b-col>
            <b-col cols='2'>
              <b-button variant="outline-success" @click="executeOperation">&nbsp;&nbsp;&nbsp;Esegui operazione&nbsp;&nbsp;&nbsp;</b-button>
            </b-col>
          </b-row>

        </b-card-body>
      </b-card>

    </b-col>
  </b-row>

  <b-row>
    <b-col cols="12">
    
      <table>
        <thead>
          <tr>
            <th style="width:  0%"></th>
            <th style="width: 10%; text-align: left;">Cliente</th>
            <th style="width: 10%; text-align: left;">Listino</th>
            <th style="width: 10%; text-align: left;">Voce</th>
            <th style="width: 10%; text-align: left;">Inizio</th>
            <th style="width: 10%; text-align: left;">Fine</th>
            <th style="width: 10%; text-align: left;">Locaz. 1</th>
            <th style="width: 10%; text-align: left;">Locaz. 2</th>
            <th style="width:  5%; text-align: left;">Base</th>
            <th style="width: 10%; text-align: left;">Formula</th>
            <th style="width:  5%; text-align: left;">Importo</th>
            <th style="width:  5%; text-align: left;">Valuta</th>
            <th style="width:  5%; text-align: left;">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in clones_list">
            <td style="width: 0%;"><span style="display: none;">{{ row.id }}</span></td>
            <td style="width: 10%;text-align: left;">{{ row.customer.company }}</td>
            <td style="width: 10%;text-align: left;">{{ row.price_list_name }}</td>
            <td style="width: 10%;text-align: left;">{{ row.voice_name }}</td>
            <td style="width: 10%;text-align: left;">{{ formatDate(row.start_date) }}</td>
            <td style="width: 10%;text-align: left;">{{ formatDate(row.end_date) }}</td>
            <td style="width: 10%;text-align: left;">{{ row.location_code1 }}</td>
            <td style="width: 10%;text-align: left;">{{ row.location_code2 }}</td>
            <td style="width: 5%;text-align: left;">{{ row.base.base_code }}</td>
            <td style="width: 10%;text-align: left;">{{ row.calculation_formula }}</td>
            <td style="width: 5%;text-align: left;">{{ row.unit_amount }}</td>
            <td style="width: 5%;text-align: left;">{{ row.currency }}</td>
            <td style="width: 5%;text-align: left;"><input type="checkbox" v-model="row.checked" @change="onCheckboxChange(row)" value="row" style="height:1.2rem;width:1.2rem;"></td>
          </tr>
        </tbody>
      </table>
    </b-col>
  </b-row>

  <b-row class="mb-3">
    <b-col cols="12">
      {{prices_list_rows}}
    </b-col>
  </b-row>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-pagination      
        v-model="currentPage"
        :total-rows="totalCount"
        :per-page="perPage"
        first-text="⏮"
        prev-text="⏪"
        next-text="⏩"
        last-text="⏭"
        class="mt-4"
      >      
      </b-pagination>

      <p>Pagina: {{ currentPage }} di {{ totalPages }}</p>

    </b-col>
  </b-row>

</div>